module.exports = __webpack_public_path__ + "img/sb.138cc349.svg";